import graphql__ae646c015d89c2d6aab2 from "./__generated__/PageSectionSidebar_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import invariant from "invariant";

import PageSectionSidebarText from "./PageSectionSidebarText";
import PageSectionSidebarLinkBlock from "./PageSectionSidebarLinkBlock";
import PageSectionSidebarUsersGroupRequestLinkBlock from "./PageSectionSidebarUsersGroupRequestLinkBlock";
import PageSectionSidebarBanner from "./PageSectionSidebarBanner";
import PageSectionSidebarEmbed from "./PageSectionSidebarEmbed";
import PageSectionSidebarFilesList from "./PageSectionSidebarFilesList";
import PageSectionSidebarPagesList from "./PageSectionSidebarPagesList";
import PageSectionSidebarAnalyticsDataList from "./PageSectionSidebarAnalyticsDataList";
import PageSectionSidebarEventsList from "./PageSectionSidebarEventsList";
import PageSectionSidebarParticipativeModuleResults from "./PageSectionSidebarParticipativeModuleResults";
import PageSectionSidebarParticipativeModulesList from "./PageSectionSidebarParticipativeModulesList";
import PageSectionSidebarCalendar from "./PageSectionSidebarCalendar";

const PageSectionTypes = {
  PageSectionSidebarText,
  PageSectionSidebarLinkBlock,
  PageSectionSidebarUsersGroupRequestLinkBlock,
  PageSectionSidebarBanner,
  PageSectionEmbed: PageSectionSidebarEmbed,
  PageSectionFilesList: PageSectionSidebarFilesList,
  PageSectionPagesList: PageSectionSidebarPagesList,
  PageSectionAnalyticsDataList: PageSectionSidebarAnalyticsDataList,
  PageSectionSidebarEventsList,
  PageSectionParticipativeModuleResults: PageSectionSidebarParticipativeModuleResults,
  PageSectionParticipativeModulesList: PageSectionSidebarParticipativeModulesList,
  PageSectionCalendar: PageSectionSidebarCalendar
};

const PageSectionSidebar = props => {
  const { pageSection } = props;
  const { __typename: typeName } = pageSection;
  const PageSectionType = PageSectionTypes[typeName];

  invariant(
    PageSectionType,
    "No PageSectionType matches section's typeName : %s",
    typeName
  );

  return <PageSectionType pageSection={pageSection} />;
};

const PageSectionSidebarContainer = createFragmentContainer(PageSectionSidebar, {
  pageSection: graphql__ae646c015d89c2d6aab2
});

export default PageSectionSidebarContainer;
